import type {
  ADMClientResponseItem,
  ADMResponse,
  AdClientResponseItem,
  SearchClientRequestProperties,
} from '@types';
import { nanoid } from 'nanoid';
import { AdClient } from './AdClient';

export class AdMarketplaceClient extends AdClient {
  /**
   * Gets ads from the adMarketplace API based on the search term.
   */
  async getAds(
    _properties: SearchClientRequestProperties,
  ): Promise<AdClientResponseItem[]> {
    const admConfig = this.config.admAdConfig;

    if (!admConfig?.sub) {
      console.error('No admSub specified in config.');
      return [];
    }

    const paramString = new URLSearchParams({
      partner: 'demofeed',
      sub1: admConfig.sub,
      qt: _properties.searchTerm,
      v: '2.0',
      rfr: 'searchcraft.io',
      'results-ta': `${admConfig.textAdQuantity || 0}`,
      'results-pa': `${admConfig.productAdQuantity || 0}`,
    }).toString();

    const path = `https://demofeed.is.ampfeed.com/is?${paramString}`;

    const response = await fetch(path, { method: 'GET' });
    const admResponse = (await response.json()) as ADMResponse;

    const productAds: ADMClientResponseItem[] = admResponse.product_ads.map(
      (ad) => ({
        id: nanoid(),
        adSource: 'adMarketplace',
        admAdType: 'adm-product-ad',
        admAd: ad,
      }),
    );

    const textAds: ADMClientResponseItem[] = admResponse.text_ads.map((ad) => ({
      id: nanoid(),
      adSource: 'adMarketplace',
      admAdType: 'adm-text-ad',
      admAd: ad,
    }));

    const allAds = productAds.concat(textAds);

    return allAds;
  }

  async onAdContainerViewed(data: {
    adClientResponseItem?: AdClientResponseItem;
    adContainerId: string;
    searchTerm: string;
  }): Promise<void> {
    // Calls fetch on the impression url, to record an impression for adMarketplace
    const item = data.adClientResponseItem as ADMClientResponseItem;
    if (item.admAd?.impression_url) {
      fetch(item.admAd.impression_url);
    }
  }
}
